import bdc from './bdc';
import thd from './thd';

import getFuncBySite from '../../utils/getFuncBySite';
import { sites } from '../../helpers/globalVariables';

export default getFuncBySite({
  [sites.blinds]: bdc,
  [sites.theHomeDepot]: thd,
});
